(function ($) {
  'use strict';

  var $card = $('#aws-telemetry-chart-card');
  var $container = $('#aws-telemetry-chart-container-new');
  var $empty = $('#aws-telemetry-chart-empty');
  var $loading = $('#aws-telemetry-chart-loading');
  var $title = $('#aws-telemetry-chart-title');
  var $sensor = $('#aws-telemetry-sensor');
  var $time = $('#waktu');
  var $periode = $('#periode');
  var chart = null;

  var SENSOR_LABELS = {
    humidity: 'Kelembapan',
    rainfall: 'Curah Hujan',
    pressure: 'Tekanan Udara',
    solarRadiation: 'Radiasi Matahari',
    sunshineHour: 'Lama Penyinaran',
    temperature: 'Suhu',
    windDirection: 'Arah Angin',
    windSpeed: 'Kecepatan Angin',
    evaporation: 'Evaporasi',
    uv: 'UV',
  };

  var SENSOR_UNITS = {
    humidity: '%',
    rainfall: 'mm',
    pressure: 'hPa',
    solarRadiation: 'W/m2',
    sunshineHour: 'jam',
    temperature: 'C',
    windDirection: '\u00B0',
    windSpeed: 'm/s',
    evaporation: 'mm',
    uv: '',
  };

  function getAwsSensorUnit(sensorKey, selectedTime) {
    return SENSOR_UNITS[sensorKey] || '';
  }

  if (!$container.length || !$sensor.length) {
    return;
  }

  var telemetryChartAjaxGuard =
    typeof createTelemetryChartLoadGuard === 'function'
      ? createTelemetryChartLoadGuard()
      : {
          start: function () {
            return {
              isCurrent: function () {
                return true;
              },
              register: function () {},
              clearIfCurrent: function () {},
            };
          },
        };

  /** Radius marker garis — seragam terkecil untuk semua grafik AWS di halaman ini. */
  var LINE_MARKER_RADIUS = 1;

  function getSelectedTime() {
    return $time.length && $time.val() ? $time.val() : 'minute';
  }

  function normalizeFilterDate(selectedTime, value) {
    var raw = (value || '').trim();
    var monthNameFormats = ['MMMM YYYY', 'MMM YYYY'];
    var dayNameFormats = ['D MMMM YYYY', 'DD MMMM YYYY', 'D MMM YYYY'];

    if (selectedTime === 'day') {
      if (moment(raw, 'YYYY', true).isValid())
        return moment(raw, 'YYYY', true).format('YYYY');
      if (moment(raw, 'YYYY-MM', true).isValid())
        return moment(raw, 'YYYY-MM', true).format('YYYY');
      if (moment(raw, 'YYYY-MM-DD', true).isValid())
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY');
      var dayParsed = moment(raw, dayNameFormats, 'id', true);
      if (!dayParsed.isValid()) dayParsed = moment(raw, dayNameFormats, true);
      if (dayParsed.isValid()) return dayParsed.format('YYYY');
      var monthParsedForYear = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsedForYear.isValid())
        monthParsedForYear = moment(raw, monthNameFormats, true);
      if (monthParsedForYear.isValid())
        return monthParsedForYear.format('YYYY');
      return moment().format('YYYY');
    }

    if (selectedTime === 'hour') {
      if (moment(raw, 'YYYY-MM', true).isValid())
        return moment(raw, 'YYYY-MM', true).format('YYYY-MM');
      if (moment(raw, 'YYYY-MM-DD', true).isValid())
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM');
      var monthParsed = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsed.isValid())
        monthParsed = moment(raw, monthNameFormats, true);
      if (monthParsed.isValid()) return monthParsed.format('YYYY-MM');
      if (moment(raw, 'YYYY', true).isValid())
        return moment().year(Number(raw)).format('YYYY-MM');
      return moment().format('YYYY-MM');
    }

    if (moment(raw, 'YYYY-MM-DD', true).isValid())
      return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM-DD');
    var dayParsedMinute = moment(raw, dayNameFormats, 'id', true);
    if (!dayParsedMinute.isValid())
      dayParsedMinute = moment(raw, dayNameFormats, true);
    if (dayParsedMinute.isValid()) return dayParsedMinute.format('YYYY-MM-DD');
    if (moment(raw, 'YYYY-MM', true).isValid())
      return moment(raw, 'YYYY-MM', true).startOf('month').format('YYYY-MM-DD');
    var monthParsedMinute = moment(raw, monthNameFormats, 'id', true);
    if (!monthParsedMinute.isValid())
      monthParsedMinute = moment(raw, monthNameFormats, true);
    if (monthParsedMinute.isValid())
      return monthParsedMinute.startOf('month').format('YYYY-MM-DD');
    if (moment(raw, 'YYYY', true).isValid())
      return moment(raw, 'YYYY', true).startOf('year').format('YYYY-MM-DD');
    return moment().format('YYYY-MM-DD');
  }

  function getFilterDate(selectedTime) {
    return normalizeFilterDate(
      selectedTime,
      $periode.length ? $periode.val() : '',
    );
  }

  function capitalizeFirst(text) {
    if (!text) {
      return '';
    }
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function getSubtitleText(selectedTime, filterDate) {
    var now = moment();

    if (selectedTime === 'day') {
      var yearMoment = moment(filterDate, 'YYYY', true).isValid()
        ? moment(filterDate, 'YYYY', true)
        : moment(filterDate, 'YYYY-MM', true).isValid()
          ? moment(filterDate, 'YYYY-MM', true)
          : moment(filterDate, 'YYYY-MM-DD', true).isValid()
            ? moment(filterDate, 'YYYY-MM-DD', true)
            : now.clone();
      var yearStart = yearMoment.clone().startOf('year');
      var yearEnd = yearMoment.isSame(now, 'year')
        ? now.clone().startOf('day')
        : yearMoment.clone().endOf('year');
      return (
        'Periode ' +
        capitalizeFirst(yearStart.locale('id').format('DD MMMM YYYY')) +
        ' sampai ' +
        capitalizeFirst(yearEnd.locale('id').format('DD MMMM YYYY'))
      );
    }

    if (selectedTime === 'hour') {
      var monthMoment = moment(filterDate, 'YYYY-MM', true).isValid()
        ? moment(filterDate, 'YYYY-MM', true)
        : moment(filterDate, 'YYYY-MM-DD', true).isValid()
          ? moment(filterDate, 'YYYY-MM-DD', true)
          : now.clone();
      var monthStart = monthMoment.clone().startOf('month');
      var monthEnd = monthMoment.isSame(now, 'month')
        ? now.clone().startOf('day')
        : monthMoment.clone().endOf('month');
      return (
        'Periode ' +
        capitalizeFirst(monthStart.locale('id').format('DD MMMM')) +
        ' sampai ' +
        capitalizeFirst(monthEnd.locale('id').format('DD MMMM YYYY'))
      );
    }

    var minuteMoment = moment(filterDate, 'YYYY-MM-DD', true).isValid()
      ? moment(filterDate, 'YYYY-MM-DD', true)
      : now.clone();
    return (
      'Periode ' +
      capitalizeFirst(minuteMoment.locale('id').format('DD MMMM YYYY'))
    );
  }

  function normalizeSensorKey(sensor) {
    if (!sensor) return '';
    var lower = String(sensor).trim().toLowerCase();
    if (lower === 'solarradiation') return 'solarRadiation';
    if (lower === 'sunshinehour') return 'sunshineHour';
    if (lower === 'windspeed') return 'windSpeed';
    if (lower === 'winddirection') return 'windDirection';
    return lower;
  }

  function getSensorOptions() {
    var raw = $('#sensor-name').val() || '';
    var options = raw
      .split(',')
      .map(function (s) {
        return normalizeSensorKey(s);
      })
      .filter(function (s, idx, arr) {
        return s && arr.indexOf(s) === idx;
      });

    var selectedTime = getSelectedTime();
    if (
      selectedTime === 'day' &&
      options.indexOf('solarRadiation') !== -1 &&
      options.indexOf('sunshineHour') === -1
    ) {
      options.push('sunshineHour');
    }

    return options;
  }

  function initSensorSelect() {
    var options = getSensorOptions();
    if (!options.length) {
      options = ['rainfall'];
    }

    $sensor.empty();
    options.forEach(function (sensor) {
      var label = SENSOR_LABELS[sensor] || sensor;
      $sensor.append($('<option/>', { value: sensor, text: label }));
    });
  }

  /** Penanda panah arah angin di atas grafik (mirip redrawCustomMarkers di detail-station.js). */
  function clearAwsWindDirectionMarkers() {
    var el = document.getElementById('aws-telemetry-chart-container-new');
    if (!el) return;
    el.querySelectorAll('.aws-wind-marker').forEach(function (marker) {
      marker.parentNode.removeChild(marker);
    });
  }

  function redrawAwsWindDirectionMarkers(hcChart) {
    var outer = document.getElementById('aws-telemetry-chart-container-new');
    if (!outer || !hcChart || !hcChart.series || !hcChart.series[0]) {
      return;
    }

    clearAwsWindDirectionMarkers();

    /** Marker HTML di atas lapisan SVG garis (anak .highcharts-container). */
    var host =
      outer.querySelector('.highcharts-container') || outer || hcChart.renderTo;

    var pts = hcChart.series[0].points || [];
    var markerBox = 22;
    var half = markerBox / 2;
    var iconPx = 20;

    pts.forEach(function (point) {
      if (
        point.x === undefined ||
        point.y === undefined ||
        !Number.isFinite(Number(point.y))
      ) {
        return;
      }
      var x = hcChart.xAxis[0].toPixels(point.x);
      var y = hcChart.yAxis[0].toPixels(point.y);

      var wrap = document.createElement('span');
      wrap.className = 'aws-wind-marker';
      wrap.style.position = 'absolute';
      wrap.style.left = x - half + 'px';
      wrap.style.top = y - half + 'px';
      wrap.style.width = markerBox + 'px';
      wrap.style.height = markerBox + 'px';
      wrap.style.display = 'inline-flex';
      wrap.style.alignItems = 'center';
      wrap.style.justifyContent = 'center';
      wrap.style.transform = 'rotate(' + point.y + 'deg)';
      wrap.style.transformOrigin = 'center center';
      wrap.style.zIndex = '50';
      wrap.style.pointerEvents = 'none';
      wrap.innerHTML =
        '<i class="mdi mdi-navigation-outline" style="font-size:' +
        iconPx +
        'px;line-height:1;color:#FF5733;"></i>';

      host.appendChild(wrap);
    });
  }

  function formatWindDirectionDisplay(y) {
    var n = Number(y);
    if (!Number.isFinite(n)) {
      return String(y);
    }
    var r = Math.round(n * 100) / 100;
    if (Math.abs(r - Math.round(r)) < 1e-9) {
      return String(Math.round(r));
    }
    return String(r);
  }

  /** Selaras Helpers/ReadingHelper.cs — GetHumidityStatus */
  function getHumidityStatusLabel(humidity) {
    var h = Number(humidity);
    if (!Number.isFinite(h)) {
      return '';
    }
    if (h >= 0 && h <= 30) {
      return 'Sangat Kering';
    }
    if (h > 30 && h <= 50) {
      return 'Kering';
    }
    if (h > 50 && h <= 70) {
      return 'Normal';
    }
    if (h > 70 && h <= 90) {
      return 'Lembab';
    }
    if (h > 90 && h <= 100) {
      return 'Sangat Lembab';
    }
    return 'Tidak Valid';
  }

  /** Selaras Helpers/ReadingHelper.cs — GetWindDirectionStatus */
  function getWindDirectionStatusLabel(degrees) {
    var v = Number(degrees);
    if (!Number.isFinite(v)) {
      return '';
    }
    if (v < 0 || v >= 360) {
      return 'Derajat harus berada di antara 0 dan 360.';
    }
    v = v % 360;
    var dirs = [
      'Utara',
      'Timur Laut',
      'Timur',
      'Tenggara',
      'Selatan',
      'Barat Daya',
      'Barat',
      'Barat Laut',
    ];
    var idx = Math.round(v / 45) % 8;
    if (idx < 0) {
      idx += 8;
    }
    return dirs[idx];
  }

  function hideCard() {
    clearAwsWindDirectionMarkers();
    if (chart) {
      chart.destroy();
      chart = null;
    }
    $card.hide();
    $loading.hide();
    $empty.hide();
    $container.hide();
  }

  function showLoading() {
    clearAwsWindDirectionMarkers();
    if (chart) {
      chart.destroy();
      chart = null;
    }
    $card.show();
    $empty.hide();
    $container.hide();
    $loading.show();
  }

  /** Samakan dengan ARR: meta judul + format tooltip. */
  function getRainfallChartMeta(selectedTime) {
    if (selectedTime === 'minute') {
      return {
        title: 'Grafik Curah Hujan Per 5 Menit',
        tooltipFormat: 'D MMMM YYYY HH:mm',
      };
    }
    if (selectedTime === 'day') {
      return {
        title: 'Grafik Curah Hujan Harian',
        tooltipFormat: 'D MMMM YYYY',
      };
    }
    return {
      title: 'Grafik Curah Hujan Jam-Jaman',
      tooltipFormat: 'D MMMM YYYY HH:mm',
    };
  }

  /** Salinan logika dari detail-station-arr-telemetry.js */
  function getIntensityThresholds(selectedTime) {
    if (selectedTime === 'day') {
      return [
        { name: 'Hujan Ringan', value: 5, color: '#90caf9' },
        { name: 'Hujan Sedang', value: 20, color: '#fad597' },
        { name: 'Hujan Lebat', value: 50, color: '#f8b584' },
        { name: 'Hujan Sangat Lebat', value: 100, color: '#f89a98' },
      ];
    }
    return [
      { name: 'Hujan Ringan', value: 0.1, color: '#90caf9' },
      { name: 'Hujan Sedang', value: 5, color: '#fad597' },
      { name: 'Hujan Lebat', value: 10, color: '#f8b584' },
      { name: 'Hujan Sangat Lebat', value: 20, color: '#f89a98' },
    ];
  }

  function getIntensityText(value, selectedTime) {
    var thresholds = getIntensityThresholds(selectedTime);
    var numVal = Number(value);
    if (!Number.isFinite(numVal) || numVal <= 0) {
      return 'Tidak Hujan';
    }
    for (var i = thresholds.length - 1; i >= 0; i--) {
      if (numVal >= thresholds[i].value) {
        return thresholds[i].name;
      }
    }
    return 'Tidak Hujan';
  }

  function buildIntensitySeries(points, selectedTime) {
    if (!points.length) {
      return [];
    }
    var thresholds = getIntensityThresholds(selectedTime);
    var maxObserved = Math.max.apply(
      null,
      points.map(function (p) {
        return p[1];
      }),
    );
    if (!Number.isFinite(maxObserved)) {
      return [];
    }
    var xValues = points.map(function (p) {
      return p[0];
    });
    return thresholds.map(function (threshold) {
      var isActive = maxObserved >= threshold.value;
      return {
        name: threshold.name,
        type: 'line',
        data: xValues.map(function (x) {
          return [x, threshold.value];
        }),
        color: threshold.color,
        lineWidth: 1,
        dashStyle: 'Dash',
        marker: { enabled: false },
        dataLabels: {
          enabled: true,
          allowOverlap: false,
          formatter: function () {
            return this.point.index === 0
              ? '<span style="color:' +
                  this.color +
                  ';font-weight:bold;">' +
                  this.series.name +
                  '</span>'
              : null;
          },
        },
        enableMouseTracking: false,
        showInLegend: true,
        visible: isActive,
      };
    });
  }

  function getZones(selectedTime) {
    if (selectedTime === 'day') {
      return [
        { value: 0, borderColor: '#4b5157', color: '#CCCCCC66' },
        { value: 20, borderColor: '#0581a1', color: '#39A6F599' },
        { value: 50, borderColor: '#a87f05', color: '#F7B84B99' },
        { value: 100, borderColor: '#a34d15', color: '#F2832399' },
        { borderColor: '#b3253a', color: '#EF535099' },
      ];
    }
    return [
      { value: 0, borderColor: '#4b5157', color: '#CCCCCC66' },
      { value: 5, borderColor: '#0581a1', color: '#39A6F599' },
      { value: 10, borderColor: '#a87f05', color: '#F7B84B99' },
      { value: 20, borderColor: '#a34d15', color: '#F2832399' },
      { borderColor: '#b3253a', color: '#EF535099' },
    ];
  }

  function getRainfallSeriesColor(selectedTime) {
    if (selectedTime === 'minute') {
      return '#22C55E';
    }
    return '#39A6F5';
  }

  function getRainfallXAxisLabelFormat(selectedTime) {
    if (selectedTime === 'day') {
      return 'DD MMM YYYY';
    }
    return 'DD MMM YYYY HH:mm';
  }

  /**
   * Samakan detail-station-arr-telemetry.js — skala Y mengikuti puncak data (+ headroom).
   */
  function computeAwsRainfallYAxisMax(points, selectedTime) {
    var dataMax = 0;
    var i;
    var y;

    for (i = 0; i < points.length; i++) {
      y = points[i][1];
      if (Number.isFinite(y)) {
        dataMax = Math.max(dataMax, y);
      }
    }

    if (dataMax <= 0) {
      if (selectedTime === 'minute') {
        return 1;
      }
      if (selectedTime === 'hour') {
        return 10;
      }
      return 10;
    }

    var cap = dataMax * 1.12 + Math.max(0.5, dataMax * 0.03);
    var step;

    if (cap <= 1) {
      step = 0.1;
    } else if (cap <= 5) {
      step = 0.5;
    } else if (cap <= 20) {
      step = 1;
    } else if (cap <= 60) {
      step = 2;
    } else if (cap <= 150) {
      step = 5;
    } else {
      step = Math.pow(10, Math.floor(Math.log10(cap)));
    }

    return Math.ceil(cap / step) * step;
  }

  /** Titik grafik AWS: { x, y, yMin?, yMax? } — harian bisa berisi min/maks untuk band seperti AWLR. */
  function parseAwsTelemetryPoints(rows, selectedTime) {
    var readingField =
      selectedTime === 'day'
        ? 'readingDate'
        : selectedTime === 'hour'
          ? 'readingHour'
          : 'readingAt';
    return rows
      .map(function (row) {
        var ts = moment.utc(row[readingField]).valueOf();
        var y = Number(row.value);
        var vmin = row.valueMin != null ? Number(row.valueMin) : NaN;
        var vmax = row.valueMax != null ? Number(row.valueMax) : NaN;
        return {
          x: ts,
          y: y,
          yMin: Number.isFinite(vmin) ? vmin : null,
          yMax: Number.isFinite(vmax) ? vmax : null,
        };
      })
      .filter(function (p) {
        return Number.isFinite(p.x) && Number.isFinite(p.y);
      })
      .sort(function (a, b) {
        return a.x - b.x;
      });
  }

  function toXYPairs(pointObjs) {
    return pointObjs.map(function (p) {
      return [p.x, p.y];
    });
  }

  /** Band min–maks harian (data sudah lengkap); arah angin tidak dipakai arearange. */
  function awsDailyUsesRangeBand(sensorKey, pointObjs, selectedTime) {
    if (selectedTime !== 'day' || sensorKey === 'windDirection') {
      return false;
    }
    return pointObjs.some(function (p) {
      return Number.isFinite(p.yMin) && Number.isFinite(p.yMax);
    });
  }

  /** Mirip getDailySeries di AWLR — garis rata-rata + arearange min–maks. */
  function getAwsDailySeries(points, seriesLabel, baseColor) {
    var avgData = points.map(function (point) {
      return {
        x: point.x,
        y: point.y,
        yMin: point.yMin,
        yMax: point.yMax,
      };
    });

    var avgSeries = {
      name: seriesLabel + ' Rata-rata',
      type: 'line',
      data: avgData,
      color: baseColor,
      lineWidth: 2,
      zIndex: 1,
      custom: {
        dailyType: 'avg',
      },
      marker: {
        enabled: true,
        radius: LINE_MARKER_RADIUS,
        fillColor: '#FFFFFF',
        lineWidth: 2,
        lineColor: baseColor,
      },
    };

    var supportsRange =
      !!(Highcharts.seriesTypes && Highcharts.seriesTypes.arearange) ||
      !!(Highcharts.seriesTypes && Highcharts.seriesTypes.areasplinerange);

    if (supportsRange) {
      var rangeType = Highcharts.seriesTypes.arearange
        ? 'arearange'
        : 'areasplinerange';

      return [
        avgSeries,
        {
          name: seriesLabel + ' Min-Maks',
          type: rangeType,
          data: points
            .filter(function (point) {
              return Number.isFinite(point.yMin) && Number.isFinite(point.yMax);
            })
            .map(function (point) {
              return [point.x, point.yMin, point.yMax];
            }),
          linkedTo: ':previous',
          color: baseColor,
          fillOpacity: 0.3,
          lineWidth: 0,
          custom: {
            dailyType: 'range',
          },
          marker: {
            enabled: false,
          },
          zIndex: 0,
        },
      ];
    }

    return [avgSeries];
  }

  /** Data pasangan [timestamp, nilai] — kolom curah hujan + garis intensitas. */
  function toPoints(rows, selectedTime) {
    return toXYPairs(parseAwsTelemetryPoints(rows, selectedTime));
  }

  function renderRainfallChart(points, selectedTime, filterDate) {
    var meta = getRainfallChartMeta(selectedTime);
    var zones = selectedTime !== 'minute' ? getZones(selectedTime) : null;
    var intensitySeries =
      selectedTime !== 'minute'
        ? buildIntensitySeries(points, selectedTime)
        : [];
    var seriesColor = getRainfallSeriesColor(selectedTime);
    var xAxisLabelFormat = getRainfallXAxisLabelFormat(selectedTime);
    var yAxisMax = computeAwsRainfallYAxisMax(points, selectedTime);

    $title.text(meta.title);

    chart = Highcharts.chart('aws-telemetry-chart-container-new', {
      chart: {
        type: 'column',
        zoomType: 'x',
      },
      navigator: {
        enabled: true,
        height: 25,
        margin: 5,
        xAxis: {
          labels: {
            style: { fontSize: '9px' },
            dateTimeLabelFormats: {
              hour: '%H:%M',
              minute: '%H:%M',
            },
          },
        },
      },
      title: { text: meta.title },
      subtitle: { text: getSubtitleText(selectedTime, filterDate) },
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        floating: false,
        itemStyle: { fontSize: '11px' },
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Waktu',
          style: { fontSize: '11px' },
        },
        labels: {
          rotation: -25,
          formatter: function () {
            return moment.utc(this.value).locale('id').format(xAxisLabelFormat);
          },
        },
      },
      yAxis: {
        min: 0,
        max: yAxisMax,
        endOnTick: false,
        gridLineWidth: 0,
        title: {
          text: 'Curah Hujan (mm)',
        },
      },
      tooltip: {
        formatter: function () {
          var fmt =
            typeof formatTelemetryTooltipNumber === 'function'
              ? formatTelemetryTooltipNumber
              : function (v) {
                  return String(v);
                };
          var dateLabel = moment
            .utc(this.x)
            .locale('id')
            .format(meta.tooltipFormat);
          var intensityLine =
            selectedTime !== 'minute'
              ? '<br/>Intensitas: <b>' +
                getIntensityText(this.y, selectedTime) +
                '</b>'
              : '';
          return (
            '<b>' +
            dateLabel +
            '</b><br/>Curah Hujan: <b>' +
            fmt(this.y) +
            ' mm</b>' +
            intensityLine
          );
        },
      },
      plotOptions: {
        column: {
          borderWidth: 1,
          pointPadding: 0,
          groupPadding: 0,
          findNearestPointBy: 'x',
          minPointLength: 3,
          animation: { duration: 500 },
        },
      },
      series: [
        {
          name: 'Curah Hujan',
          type: 'column',
          data: points,
          color: seriesColor,
          zones: zones || undefined,
          zoneAxis: zones ? 'y' : undefined,
        },
      ].concat(intensitySeries),
      credits: { enabled: false },
    });
  }

  /**
   * Arah angin: tooltip teks (SVG) — hindari useHTML + tag mdi karena disaring Highcharts sehingga tooltip kosong.
   * Penanda panah: mdi-navigation-outline, di atas garis.
   */
  function renderWindDirectionChart(points, selectedTime, filterDate) {
    var sensorLabel = SENSOR_LABELS.windDirection;
    var tooltipFormat =
      selectedTime === 'day' ? 'D MMMM YYYY' : 'D MMMM YYYY HH:mm';

    $title.text('Grafik ' + sensorLabel);
    $container.css({ position: 'relative', overflow: 'visible' });

    chart = Highcharts.chart('aws-telemetry-chart-container-new', {
      chart: {
        type: 'line',
        zoomType: 'x',
        events: {
          load: function () {
            redrawAwsWindDirectionMarkers(this);
          },
          redraw: function () {
            redrawAwsWindDirectionMarkers(this);
          },
        },
      },
      navigator: { enabled: true, height: 25, margin: 5 },
      title: { text: 'Grafik ' + sensorLabel },
      subtitle: { text: getSubtitleText(selectedTime, filterDate) },
      xAxis: {
        type: 'datetime',
        labels: {
          rotation: -45,
          formatter: function () {
            return moment
              .utc(this.value)
              .locale('id')
              .format(
                selectedTime === 'day' ? 'DD MMM YYYY' : 'DD MMM YYYY HH:mm',
              );
          },
        },
      },
      yAxis: {
        title: {
          text: 'Arah Angin (&deg;)',
          useHTML: true,
        },
        gridLineWidth: 0,
      },
      tooltip: {
        useHTML: false,
        formatter: function () {
          var fmt =
            typeof formatTelemetryTooltipNumber === 'function'
              ? formatTelemetryTooltipNumber
              : formatWindDirectionDisplay;
          var pt = this.point;
          var xv = pt != null ? pt.x : this.x;
          var yv = pt != null ? pt.y : this.y;
          if (!Number.isFinite(yv)) {
            return '';
          }
          var dateLabel = moment.utc(xv).locale('id').format(tooltipFormat);
          var deg = fmt(yv);
          var dir = getWindDirectionStatusLabel(yv);
          var out =
            '<b>' +
            dateLabel +
            '</b><br/>' +
            sensorLabel +
            ': <b>' +
            deg +
            '\u00B0</b>';
          if (dir) {
            out += '<br/><b>' + dir + '</b>';
          }
          return out;
        },
      },
      plotOptions: {
        line: {
          marker: {
            enabled: false,
            radius: LINE_MARKER_RADIUS,
            symbol: 'circle',
          },
          lineWidth: 2,
          zIndex: 1,
        },
      },
      series: [
        {
          name: sensorLabel,
          type: 'line',
          data: points,
          color: '#FF5733',
          zIndex: 1,
        },
      ],
      credits: { enabled: false },
    });
  }

  function renderLineChart(pointObjs, selectedTime, filterDate, sensor) {
    var sensorLabel = SENSOR_LABELS[sensor] || sensor;
    var unit = getAwsSensorUnit(sensor, selectedTime);
    var tooltipFormat =
      selectedTime === 'day' ? 'D MMMM YYYY' : 'D MMMM YYYY HH:mm';

    var useDailyRange = awsDailyUsesRangeBand(sensor, pointObjs, selectedTime);
    var lineColor = '#FF5733';

    var series = useDailyRange
      ? getAwsDailySeries(pointObjs, sensorLabel, lineColor)
      : [
          {
            name: sensorLabel,
            type: 'line',
            data: toXYPairs(pointObjs),
            color: lineColor,
          },
        ];

    var tooltipCfg = useDailyRange
      ? {
          shared: true,
          crosshairs: true,
          formatter: function () {
            var fmt =
              typeof formatTelemetryTooltipNumber === 'function'
                ? formatTelemetryTooltipNumber
                : function (v) {
                    return String(v);
                  };
            var dateLabel = moment
              .utc(this.x)
              .locale('id')
              .format(tooltipFormat);
            var rowsOut = ['<b>' + dateLabel + '</b>'];

            if (this.points && this.points.length) {
              var avgPoint = this.points.find(function (point) {
                return (
                  point.series &&
                  point.series.userOptions &&
                  point.series.userOptions.custom &&
                  point.series.userOptions.custom.dailyType === 'avg'
                );
              });

              var rangePoint = this.points.find(function (point) {
                return (
                  point.point &&
                  Number.isFinite(point.point.low) &&
                  Number.isFinite(point.point.high)
                );
              });

              if (avgPoint) {
                rowsOut.push(
                  sensorLabel +
                    ' Rata-rata: <b>' +
                    fmt(avgPoint.y) +
                    ' ' +
                    unit +
                    '</b>',
                );
              }

              if (rangePoint) {
                rowsOut.push(
                  'Range: <b>' +
                    fmt(rangePoint.point.low) +
                    ' ' +
                    unit +
                    ' - ' +
                    fmt(rangePoint.point.high) +
                    ' ' +
                    unit +
                    '</b>',
                );
              } else if (
                avgPoint &&
                avgPoint.point &&
                Number.isFinite(avgPoint.point.yMin) &&
                Number.isFinite(avgPoint.point.yMax)
              ) {
                rowsOut.push(
                  'Range: <b>' +
                    fmt(avgPoint.point.yMin) +
                    ' ' +
                    unit +
                    ' - ' +
                    fmt(avgPoint.point.yMax) +
                    ' ' +
                    unit +
                    '</b>',
                );
              }
            } else {
              rowsOut.push(
                sensorLabel + ': <b>' + fmt(this.y) + ' ' + unit + '</b>',
              );
            }

            return rowsOut.join('<br/>');
          },
        }
      : {
          formatter: function () {
            var fmt =
              typeof formatTelemetryTooltipNumber === 'function'
                ? formatTelemetryTooltipNumber
                : function (v) {
                    return String(v);
                  };
            var pt = this.point;
            var xv = pt != null ? pt.x : this.x;
            var yv = pt != null ? pt.y : this.y;
            var dateLabel = moment.utc(xv).locale('id').format(tooltipFormat);
            var lines =
              '<b>' +
              dateLabel +
              '</b><br/>' +
              sensorLabel +
              ': <b>' +
              fmt(yv) +
              (unit ? ' ' + unit : '') +
              '</b>';
            if (sensor === 'humidity') {
              var humStat = getHumidityStatusLabel(yv);
              if (humStat) {
                lines += '<br/><b>' + humStat + '</b>';
              }
            }
            return lines;
          },
        };

    $title.text('Grafik ' + sensorLabel);

    chart = Highcharts.chart('aws-telemetry-chart-container-new', {
      chart: { type: 'line', zoomType: 'x' },
      navigator: { enabled: true, height: 25, margin: 5 },
      title: { text: 'Grafik ' + sensorLabel },
      subtitle: { text: getSubtitleText(selectedTime, filterDate) },
      xAxis: {
        type: 'datetime',
        labels: {
          rotation: -45,
          formatter: function () {
            return moment
              .utc(this.value)
              .locale('id')
              .format(
                selectedTime === 'day' ? 'DD MMM YYYY' : 'DD MMM YYYY HH:mm',
              );
          },
        },
      },
      yAxis: {
        title: { text: sensorLabel + (unit ? ' (' + unit + ')' : '') },
        gridLineWidth: 0,
      },
      tooltip: tooltipCfg,
      plotOptions: {
        line: {
          marker: {
            enabled: !useDailyRange,
            radius: LINE_MARKER_RADIUS,
          },
          lineWidth: 2,
        },
      },
      series: series,
      credits: { enabled: false },
    });
  }

  function renderChart(pointObjs, selectedTime, filterDate, sensor) {
    clearAwsWindDirectionMarkers();
    if (chart) {
      chart.destroy();
      chart = null;
    }

    $card.show();
    $loading.hide();
    $empty.hide();
    $container.show();

    var pairs = toXYPairs(pointObjs);

    if (sensor === 'rainfall') {
      renderRainfallChart(pairs, selectedTime, filterDate);
    } else if (sensor === 'windDirection') {
      renderWindDirectionChart(pairs, selectedTime, filterDate);
    } else {
      renderLineChart(pointObjs, selectedTime, filterDate, sensor);
    }
  }

  function loadChart() {
    if (typeof Highcharts === 'undefined') {
      hideCard();
      return;
    }

    var selectedTime = getSelectedTime();
    var filterDate = getFilterDate(selectedTime);
    var sensor = normalizeSensorKey($sensor.val());

    var g = telemetryChartAjaxGuard.start();
    showLoading();

    var jqXHR = $.ajax({
      url: '/Station/GetChartDataAws',
      type: 'POST',
      data: {
        deviceId: deviceId,
        selectedTime: selectedTime,
        filterDate: filterDate,
        sensor: sensor,
      },
    });
    g.register(jqXHR);

    jqXHR
      .done(function (response) {
        if (!g.isCurrent()) {
          return;
        }
        var rows = response && response.data ? response.data : [];
        var pointObjs = parseAwsTelemetryPoints(rows, selectedTime);
        if (!pointObjs.length) {
          hideCard();
          return;
        }
        renderChart(pointObjs, selectedTime, filterDate, sensor);
      })
      .fail(function (_xhr, status) {
        if (status === 'abort') {
          return;
        }
        if (!g.isCurrent()) {
          return;
        }
        hideCard();
      })
      .always(function () {
        g.clearIfCurrent();
      });
  }

  function init() {
    initSensorSelect();
    $sensor.on('change', loadChart);
    if ($time.length) {
      $time.on('change', function () {
        initSensorSelect();
        loadChart();
      });
    }
    if ($periode.length) $periode.on('change', loadChart);
    $('a[data-bs-toggle="tab"][href="#tab-data-telemetri"]').on(
      'shown.bs.tab',
      loadChart,
    );
    loadChart();
  }

  init();
})(jQuery);
